import { PackageProcessServiceBase, WsPackageProcess } from "./wsdl/WsPackageProcess/v1.08/WsPackageProcess.ts";

export {
    type WsPackageProcess
};

export class PackageProcessService extends PackageProcessServiceBase {
}
